// 仅使用类型
export var getClosestNode = function getClosestNode(node, until) {
  if (!node) {
    return undefined;
  }

  if (until(node)) {
    return node;
  } else {
    // @ts-ignore
    return getClosestNode(node.getParent(), until);
  }
};
/**
 * 判断节点是否可被点击
 * @param {Node} node 节点
 * @param {unknown} e 点击事件
 * @returns {boolean} 是否可点击，true表示可点击
 */

export var canClickNode = function canClickNode(node, e) {
  var _node$componentMeta, _node$componentMeta$g, _node$componentMeta$g2, _node$componentMeta$g3;

  var onClickHook = (_node$componentMeta = node.componentMeta) === null || _node$componentMeta === void 0 ? void 0 : (_node$componentMeta$g = _node$componentMeta.getMetadata().configure) === null || _node$componentMeta$g === void 0 ? void 0 : (_node$componentMeta$g2 = _node$componentMeta$g.advanced) === null || _node$componentMeta$g2 === void 0 ? void 0 : (_node$componentMeta$g3 = _node$componentMeta$g2.callbacks) === null || _node$componentMeta$g3 === void 0 ? void 0 : _node$componentMeta$g3.onClickHook;
  var canClick = typeof onClickHook === 'function' ? onClickHook(e, node) : true;
  return canClick;
};